import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { renderInput } from 'src/components/misc/redux-form-helpers';
import autoBind from 'react-autobind';
import MenuItem from 'material-ui/MenuItem';

import { connect } from 'react-redux';
import SelectField from 'material-ui/SelectField';
import _ from 'lodash';
import { isBlank } from 'src/components/misc/validations';

const renderSeasonAndCalculationsError = ({ meta: { touched, error, submitFailed } }) => {
    if (!(touched || submitFailed) || !error) return null;
    const message = typeof error === 'string' ? error : error._error;
    if (!message) return null;
    return <span className="error">{message}</span>;
};

class CalendarSeasonCalculationForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            isDisabled: true,
            calculationValue: undefined,
            calendarSeasonValue: undefined,
            seasonAndCalculations: props.initialValues.seasonAndCalculations || [],
        };
    }

    render() {
        const { handleSubmit, t, calculations, calendarSeasons } = this.props;

        const calendarSeasonItems = [];
        const calculationItems = [];

        calculations.items.forEach((value, index) => {
            calculationItems.push(<MenuItem key={index} value={value.id} primaryText={value.name} />);
        });

        calendarSeasons.items.forEach((value, index) => {
            calendarSeasonItems.push(<MenuItem key={index} value={value.id} primaryText={value.name} />);
        });

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="name"
                            label={`${t('common_phrases.name')} *`}
                            hintText={t('calendar_season_calculation.form.name_hint')}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="row bus-calculation-flex voffset">
                    <div className="col-md-6">
                        <div className="">
                            <SelectField
                                value={this.state.calendarSeasonValue}
                                onChange={(event, index, value) => {
                                    this.setState({
                                        calendarSeasonValue: value,
                                    });
                                }}
                                floatingLabelText={t('calendar_season_calculation.form.season')}
                                fullWidth={true}
                                hintText={t('calendar_season_calculation.form.season')}
                                floatingLabelFixed={true}>
                                {calendarSeasonItems}
                            </SelectField>
                        </div>
                        <div className="">
                            <SelectField
                                value={this.state.calculationValue}
                                onChange={(event, index, value) => {
                                    this.setState({
                                        calculationValue: value,
                                    });
                                }}
                                floatingLabelText={t('bus.calculation')}
                                fullWidth={true}
                                hintText={t('bus.calculation')}
                                floatingLabelFixed={true}>
                                {calculationItems}
                            </SelectField>
                        </div>
                    </div>
                    <div className="col-md-1 voffset">
                        <button
                            type="button"
                            className="btn btn-xs transparent"
                            onClick={this.handleAddSeasonAndCalculation}>
                            {this.state.calendarSeasonValue &&
                            this.state.calculationValue &&
                            !this.state.seasonAndCalculations.find(
                                calc => calc.calendarSeason.id === this.state.calendarSeasonValue,
                            ) ? (
                                <span
                                    className="fa fa-arrow-circle-right fa-2x text-success"
                                    title={t('calendar_season_calculation.error.combination_exists')}
                                />
                            ) : this.state.seasonAndCalculations.find(
                                  calc => calc.calendarSeason.id === this.state.calendarSeasonValue,
                              ) ? (
                                <span
                                    className="fa fa-arrow-circle-right fa-2x"
                                    title={t('calendar_season_calculation.error.combination_exists')}
                                />
                            ) : (
                                <>
                                    <span
                                        className="fa fa-arrow-circle-right fa-2x"
                                        title={t('busDiscountCalculation.error_add_bus_calculation')}
                                    />
                                </>
                            )}
                        </button>
                    </div>
                    <div className="col-md-7">
                        <label className="control-label">
                            {t('calendar_season_calculation.form.selected_combinations')}{' '}
                        </label>

                        <Field name="seasonAndCalculations" component={renderSeasonAndCalculationsError} />

                        <ul className="list-group" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                            {this.state.seasonAndCalculations.length === 0 ? (
                                <span className="error">
                                    {t('calendar_season_calculation.error.please_select_combination')}
                                </span>
                            ) : (
                                <div>
                                    {this.state.seasonAndCalculations.map((item, index) => (
                                        <li key={index} className="list-group-item">
                                            <span>
                                                {item.calculation.name}
                                                &nbsp; | &nbsp;
                                                {item.calendarSeason.name} &nbsp;
                                            </span>
                                            <span className="glyphicon glyphicon-ok text-success" />
                                            <button
                                                type="button"
                                                className="btn btn-xs transparent pull-right"
                                                onClick={() => this.handleDeleteSeasonAndCalculation(item)}>
                                                <span className="glyphicon glyphicon-trash" />
                                            </button>
                                        </li>
                                    ))}
                                </div>
                            )}
                        </ul>
                    </div>
                </div>
            </form>
        );
    }

    handleAddSeasonAndCalculation() {
        if (this.state.calendarSeasonValue && this.state.calculationValue) {
            const { calculations, calendarSeasons } = this.props;

            const alreadyInCalculation = this.state.seasonAndCalculations.find(
                calc => calc.calendarSeason.id === this.state.calendarSeasonValue,
            );
            if (alreadyInCalculation) return;
            const tmpCalculations = calculations.items;
            const currentSelectedSeason = calendarSeasons.items.find(
                season => season.id === this.state.calendarSeasonValue,
            );
            const currentSelectedCalculation = tmpCalculations.find(calc => calc.id === this.state.calculationValue);

            if (currentSelectedSeason && currentSelectedCalculation) {
                const combination = {
                    calendarSeason: currentSelectedSeason,
                    calculation: currentSelectedCalculation,
                };
                this.props.array.push('seasonAndCalculations', combination);
                this.setState({
                    seasonAndCalculations: this.state.seasonAndCalculations.concat({
                        calendarSeason: currentSelectedSeason,
                        calculation: currentSelectedCalculation,
                    }),
                    calendarSeasonValue: undefined,
                    calculationValue: undefined,
                });
            }
        }
    }

    handleDeleteSeasonAndCalculation(item) {
        this.props.array.remove(
            'seasonAndCalculations',
            this.state.seasonAndCalculations.findIndex(_item => _item.calendarSeason.id === item.calendarSeason.id),
        );
        if (
            this.props.initialValues.seasonAndCalculations &&
            this.props.initialValues.seasonAndCalculations.length === 0
        ) {
            this.setState({
                seasonAndCalculations: _.without(this.state.seasonAndCalculations, item),
                isDisabled: true,
            });
        } else {
            this.setState({
                seasonAndCalculations: _.without(this.state.seasonAndCalculations, item),
            });
        }
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};
    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');
    const seasonAndCalculations = values.seasonAndCalculations || [];
    if (seasonAndCalculations.length === 0) {
        errors.seasonAndCalculations = { _error: t('calendar_season_calculation.form.no_selected_combinations') };
    }

    return errors;
};
const selector = formValueSelector('calendarSeasonCalculationForm');

const mapStateToProps = state => {
    return {
        isDefault: selector(state, 'isDefault'),
    };
};

export default reduxForm({
    form: 'calendarSeasonCalculationForm',
    validate,
    asyncBlurFields: ['name'],
})(connect(mapStateToProps)(CalendarSeasonCalculationForm));
